import axios from "axios";
import { Component } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import DatePicker from 'react-datepicker';
import { validateApplicationForm } from "../utils/validation";
import CommonLoader from "./loaderComponent/CommonLoader";
import CommonToast from "./Toaster/CommonToast";

export default class Application extends Component {

  constructor(props) {
    super(props);

    this.state = {
      type: "",
      startDate: null,
      endDate: null,
      reason: "",
      hasError: false,
      errMsg: "",
      completed: false,
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
      loading: true,

    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    console.log("pkkkkk", id);

    if (id) {
      axios({
        method: "get",
        url: `/applications/appid/${id}`,
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
        .then((res) => {
          const { type, startDate, endDate, reason } = res.data;
          this.setState({
            type,
            startDate: new Date(startDate),
            endDate: new Date(endDate),
            reason,
            loading: false,
          });
        })
        .catch((err) => {
          console.error("Error fetching application:", err);
          this.setState({ loading: false });
        });
    } else {
      this.setState({ loading: false });
    }
    setTimeout(() => {
      this.setState({ loading: false });
    }, 900);
  }
  handleChange = (event) => {

    const { value, name } = event.target;
    let errors = { ...this.state.errors };
    if (name === "type" && value.trim()) {
      delete errors.type;
    }
    this.setState({
      [name]: value,
      errors
    });
  };
  // handleDateChange = (date, field) => {
  //   let errors = { ...this.state.errors };

  //   if (field === "startDate") {
  //     this.setState({
  //       startDate: date,
  //       targetDate: date,
  //       endDate: null,
  //       errors: { ...errors, startDate: undefined },
  //     });
  //   }

  //   if (field === "endDate") {
  //     if (date < this.state.targetDate) {
  //       errors.endDate = "End date must be on or after start date.";
  //     } else {
  //       delete errors.endDate;
  //     }

  //     this.setState({
  //       endDate: date,
  //       errors,
  //     });
  //   }
  // };
  handleDateChange = (date, field) => {
    let errors = { ...this.state.errors };

    if (!date) {
      this.setState({ [field]: null });
      return;
    }

    // Convert selected date to local midnight
    const localDate = new Date(date);
    localDate.setHours(0, 0, 0, 0); // Ensure no time shift

    if (field === "startDate") {
      this.setState({
        startDate: localDate,
        targetDate: localDate,
        endDate: null,
        errors: { ...errors, startDate: undefined },
      });
    }

    if (field === "endDate") {
      if (localDate < this.state.targetDate) {
        errors.endDate = "End date must be on or after start date.";
      } else {
        delete errors.endDate;
      }

      this.setState({
        endDate: localDate,
        errors,
      });
    }
  };
  formatDate = (date) => {
    return date ? new Date(date).toLocaleDateString('en-CA') : null;
  };

  onSubmit = (e) => {
    e.preventDefault();
    const errors = validateApplicationForm(
      this.state.type,
      this.state.startDate,
      this.state.endDate
    );
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }
    // this.setState({ hasError: false, errorMsg: "", completed: false });
    let userId = JSON.parse(localStorage.getItem('user')).id;
    const { id } = this.props.match.params;

    let applicationForAdd = {
      type: this.state.type,
      // this.formatDate(this.state.startDate),
      startDate: this.formatDate(this.state.startDate),
      endDate: this.formatDate(this.state.endDate),
      status: 'Pending',
      reason: this.state.reason,
      userId: userId
    };
    let applicationForEdit = {
      id: id || undefined,
      type: this.state.type,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      status: 'Pending',
      reason: this.state.reason
    };
    // if (id) {
    //   application.id = id;
    // }
    const requestConfig = {
      method: "post",
      url: id ? "/applications/modify" : "/applications",
      data: id ? applicationForEdit : applicationForAdd,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    axios(requestConfig)
      .then((res) => {
        this.setState({
          completed: true,
          toastMessage: id ? 'Leave updated successfully!' : 'Leave applied successfully!',
          toastVariant: 'success',
          color: 'green',
          done: true,
          showToast: true,
        });

        setTimeout(() => {
          this.setState({ loading: false, showToast: false });
          this.props.history.push("/application-list");
        }, 1000);

      })
      .catch((err) => {
        this.setState({
          toastMessage: err.response.data.message,
          toastVariant: 'danger',
          color: 'red',
          showToast: true,
          loading: false
        });
        // this.setState({ hasError: true, errMsg: err.response.data.message });
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
        window.scrollTo(0, 0);
      });
  };

  handleBack = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.props.history.push("/application-list");
      this.setState({ loading: false });
    }, 500);
  };

  render() {
    return (
      <div className="pt-4">
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />

        <CommonLoader isLoading={this.state.loading}>
          < >
            {/* {this.state.hasError ? (
              <Alert variant="danger" className="m-3" block>
                {this.state.errMsg}
              </Alert>
            ) : this.state.completed ? (
              <Redirect to="/application-list" />
              
            ) : (<></>)} */}
            <Card className="shadow-sm rounded border-0">
              <Card.Header className="text-white">
                <strong> {this.props.match.params.id ? "Update Leaves" : "Make Leaves"}</strong>
              </Card.Header>
              <Card.Body>
                <>
                  <Form onSubmit={this.onSubmit}>

                    <Row className="mb-3">
                      <Col xs={12} md={3} lg={3}>
                        <Form.Group controlId="formDepartmentName">
                          <Form.Label className="required">
                            Type
                          </Form.Label>
                          <Form.Control
                            as="select"
                            className="form-select"
                            name="type"
                            value={this.state.type}
                            onChange={this.handleChange}

                          >
                            <option value="">Choose one</option>
                            <option value="Casual Leave">Casual Leave</option>
                            <option value="Sick Leave">Sick Leave</option>
                            <option value="LWP">LWP</option>
                            {/* <option value="marriage">Marriage</option> */}
                          </Form.Control>
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.type && <small className="text-danger">{this.state.errors.type}</small>}
                        </span>
                      </Col>
                      <Col xs={12} md={3} lg={3}>
                        <Form.Group>
                          <Form.Label className="required">Start Date</Form.Label>
                          {/* <Form.Row>
                        <DatePicker
                          selected={this.state.startDate}
                          className="form-control ml-1"
                          placeholderText="Select start date"
                          onChange={newDate => this.setState({ startDate: newDate })}
                          required
                        />
                      </Form.Row> */}
                          <DatePicker
                            selected={this.state.startDate}
                            className="form-control "
                            dateFormat="dd/MM/yyyy"
                            onChange={date => this.handleDateChange(date, 'startDate')}
                            placeholderText="Select start date"
                            minDate={new Date(new Date().getFullYear(), new Date().getMonth(), 1)}
                          />
                          <span className="login-error">
                            {this.state.errors.startDate && <small className="text-danger">{this.state.errors.startDate}</small>}
                          </span>
                        </Form.Group>
                      </Col>
                      <Col xs={12} md={3} lg={3}>
                        <Form.Group>
                          <Form.Label className="required">End Date</Form.Label>
                          {/* <Form.Row>
                        <DatePicker
                          selected={this.state.endDate}
                          className="form-control ml-1"
                          placeholderText="Select end date"
                          onChange={newDate => this.setState({ endDate: newDate })}
                          required
                        />
                      </Form.Row> */}
                          <DatePicker
                            selected={this.state.endDate}
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            onChange={date => this.handleDateChange(date, 'endDate')}
                            placeholderText="Select end date"
                            minDate={this.state.targetDate || this.state.startDate}
                            disabled={!this.state.startDate || !this.state.targetDate}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                          />
                          <span className="login-error">
                            {this.state.errors.endDate && <small className="text-danger">{this.state.errors.endDate}</small>}
                          </span>
                        </Form.Group>
                      </Col>
                      <Col xs={12} md={3} lg={3}>
                        <Form.Group>
                          <Form.Label>Reason <span className="text-muted">(Comments)</span></Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={1}
                            name="reason"
                            placeholder="Enter reason"
                            value={this.state.reason}
                            onChange={this.handleChange}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className='add-cancel-btn '>
                      <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" type="submit" size="d">
                        {this.props.match.params.id ? "Update" : "Add"}
                      </Button>
                      <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" onClick={this.handleBack}>Cancel</Button>
                    </div>
                  </Form>
                </>
              </Card.Body>
            </Card>
          </>
        </CommonLoader>
      </div>
    );
  }
}